<template>
    <div class="edit-document">
        <PageContent class="batch-edit-wrapper">
            <span class="summary-title">
                Please review and confirm your submission
            </span>
            <PanelV2
                type="w6"
                title=""
                @nextClick="saveForms()"
                mode="edit"
            >
                <template v-slot:title-solt>
                </template>
                <template v-slot:content-solt>
                    <EditUpload class="half-wrap" label="Selfie with your ID" title="Selfie with ID" :imgValue="idCardiUrl" @uploadData="uploadData" @removeData="removeData" />
                    <EditUpload v-if="isShowSec" class="half-wrap" label="SEC Certificate" title="Photo of SEC Certificate" :imgValue="secUrl" :exceedNumber="30" @uploadData="uploadData" @removeData="removeData" />
                    <EditUpload v-if="isShowDti" class="half-wrap" label="DTI Certificate" title="Photo of DTI Certificate" :imgValue="dtiUrl" @uploadData="uploadData" @removeData="removeData" />
                    <div class="store">
                        <EditUpload label="Store Photo" title="Exterior" :imgValue="exterior" :ekycStatus="ekycStatus" @uploadData="uploadData" @removeData="removeData" />
                        <div class="blank"></div>
                        <EditUpload label="" title="Interior" :imgValue="interior" :ekycStatus="ekycStatus" @uploadData="uploadData" @removeData="removeData" />
                    </div>
                </template>
            </PanelV2>
        </PageContent>
    </div>
</template>

<script>
    import API from "@/api";
    import EditUpload from "../components/EditUpload"
    export default {
        name: 'EditPayment',
        components:{
            EditUpload,
        },
        data() {
            return {
                secUrl: '',
                idCardiUrl: '',
                dtiUrl: '',
                exterior: [],
                interior: [],
                processNo: '',
                ekycStatus: '',
            }
        },
        created() {
            this.init()
        },
        computed: {
            isShowDti() {
                return this.processNo == '2'
            },
            isShowSec() {
                return ['3','4'].includes(String(this.processNo))
            }
        },
        methods: {
            init() {
                API.getBdoProcessData({
                    token: this.getCookieItem('token'),
                    pageNo: 999,
                }).then((res) => {
                    this.processNo = res.obj.processNo
                    this.idCardiUrl = res.obj.selfieWithIDPhoto && res.obj.selfieWithIDPhoto.idCardiUrl || ''
                    this.secUrl = res.obj.secPhoto && res.obj.secPhoto.secUrl || ''
                    this.dtiUrl = res.obj.dtiPhoto && res.obj.dtiPhoto.dtiUrl || ''
                    this.exterior = res.obj.storePhoto && res.obj.storePhoto.exterior || []
                    this.interior = res.obj.storePhoto && res.obj.storePhoto.interior || []
                    this.ekycStatus = res.obj.ekycStatus
                })
            },
            uploadData({name, data, isAdd}) {
                if(name == 'Selfie with ID') {
                    this.idCardiUrl = data
                }
                if(name == 'Photo of SEC Certificate') {
                    this.secUrl = data
                }
                if(name == 'Photo of DTI Certificate') {
                    this.dtiUrl = data
                }
                if(name == 'Exterior') {
                    let arr = [...this.exterior, ...data]
                    this.exterior = isAdd ? [...this.exterior, ''] : [...new Set(arr)]
                }
                if(name == 'Interior') {
                    let arr = [...this.interior, ...data]
                    this.interior = isAdd ? [...this.interior, ''] :  [...new Set(arr)]
                }
            },

            removeData ({name, index}) {
                let arr = [];
                if(name == 'Selfie with ID') {
                    this.idCardiUrl = ''
                }
                if(name == 'Photo of SEC Certificate') {
                    arr = this.secUrl.split(',')
                    arr.splice(index, 1)
                    this.secUrl = arr.join(',')
                }
                if(name == 'Photo of DTI Certificate') {
                    arr = this.dtiUrl.split(',')
                    arr.splice(index, 1)
                    this.dtiUrl = arr.join(',')
                }
                if(name == 'Exterior') {
                    arr = [...this.exterior];
                    arr.splice(index, 1)
                    this.exterior = arr
                }
                if(name == 'Interior') {
                    arr = [...this.interior];
                    arr.splice(index, 1)
                    this.interior = arr
                }
            },
            saveForms() {
                if(!this.idCardiUrl) {
                    this.showMessageTip('Upload your selfie with ID');
                    return
                }
                if(this.exterior.includes('') || this.interior.includes('')){
                    this.showMessageTip('must upload File!');
                    return
                }
                const obj = {
                    '1': {  pageNo: "11,14",
                            selfieWithIDPhoto: {
                                idCardiUrl: this.idCardiUrl
                            },
                            storePhoto: {
                                exterior: this.exterior,
                                interior: this.interior
                            }
                        },
                    '2': {  pageNo: "11,12,14",
                            selfieWithIDPhoto: {
                                idCardiUrl: this.idCardiUrl
                            },
                            dtiPhoto: {
                                dtiUrl: this.dtiUrl
                            },
                            storePhoto: {
                                exterior: this.exterior,
                                interior: this.interior
                            }
                        },
                    '3': {  pageNo: "11,13,14",
                            selfieWithIDPhoto: {
                                idCardiUrl: this.idCardiUrl
                            },
                            secPhoto: {
                                secUrl: this.secUrl
                            },
                            storePhoto: {
                                exterior: this.exterior,
                                interior: this.interior
                            }
                        },
                    '4': {  pageNo: "11,13,14",
                            selfieWithIDPhoto: {
                                idCardiUrl: this.idCardiUrl
                            },
                            secPhoto: {
                                secUrl: this.secUrl
                            },
                            storePhoto: {
                                exterior: this.exterior,
                                interior: this.interior
                            }
                        }
                }
                API.editBdoProcess({
                    token: this.getCookieItem('token'),
                    ...obj[this.processNo]
                }).then(res => {
                    if(res.success) {
                        window.history.go(-1);
                    }
                })
            }
        }
    }
</script>


<style lang="scss" scoped>
.edit-document {
    .panel-v2.content-area {
        margin: 16px 0;
    }
    ::v-deep .content {
        padding: 0;
            align-items: flex-start;
    }
    .store {
        display: flex;
        justify-content: space-between;
        .blank {
            width: 24px;
        }
        .edit-upload{
            flex: 1;
        }
    }
}
.half-wrap {
  width: 50% !important;
  padding-right: 12px;
}
</style>
